export default __webpack_public_path__ + "static/media/fNeutral8.e85274da.png";